import React, {useState} from 'react';
import {makeStyles, useTheme, ThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import {} from '@material-ui/icons';
import { green, purple } from '@material-ui/core/colors';
import { useForm } from 'react-final-form-hooks'
import ABI from "../receive/ABI";
import TomoZABI from "./TomoZABI";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import web3Service, {web3} from 'Backend/Web3'
import useLoading from 'Frontend/components/loading/hook'
import LoadingUi from 'Frontend/components/loading/ui'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        bottom: 0,
        textAlign: 'center'
    },
    rootSpan: {
        fontSize: 20,
        margin: 5
    },
    margin: {
        margin: theme.spacing(1),
    },
}));

const theme = createMuiTheme({
    palette: {
        primary: green,
    },
});
export default function FullWidthTabs({metamask, config}) {
    const classes = useStyles();
    const [owner, setOwner] = useState('')
    const [tokenCapacity, setTokenCapacity] = useState(0)
    const [loading, withLoading] = useLoading()
    const checkOwnerContract =  async () => {
        const web3Read = await  web3Service.web3Read()
        const contractAddress = config.contractReceiveLink
        const contract = new web3Read.eth.Contract(ABI, contractAddress)
        return contract.methods.owner().call()
    }

    const checkTomoZ = async () => {

        const web3Read = await  web3Service.web3Read()
        const contractAddress = config.tomoZUrl
        const contract = new web3Read.eth.Contract(TomoZABI, contractAddress)
        return contract.methods.getTokenCapacity(config.contractReceiveLink).call().then(res => web3.fromWei(res, 'ether').toString())
    }

    React.useEffect( () => {
        metamask.isSigned && withLoading(() => Promise.all([checkOwnerContract().then(setOwner), checkTomoZ().then(setTokenCapacity)]))

    }, [])
    return (
        <div className={classes.root}>
            {metamask.isSigned && loading && <LoadingUi/>}
            <Card className={classes.root} variant="outlined">
                <CardContent>
                    <div className={classes.rootSpan}><span>Contract address</span></div>

                    <div>

                        <a target="_blank"
                           href={config.exploreUrl + 'address/' + config.contractReceiveLink}>{config.contractReceiveLink}</a>
                    </div>
                    <div className={classes.rootSpan}><span>Donation to contract's owner address</span></div>
                    <div><a target="_blank" href={config.exploreUrl + 'address/' + owner}>{owner}</a></div>
                    <div className={classes.rootSpan}><span>Tomo left for user's gas fee</span></div>
                    <div><h4>{tokenCapacity} TOMO</h4></div>
                </CardContent>

            </Card>

        </div>
    );
}
